function PageHeader({ title }) {
    return (
        <div className="relative h-[50vh] md:h-[70vh] mb-8">
            <div
                className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center">
                <h1 className="text-5xl md:text-6xl font-bold text-white text-center px-4">
                    {title}
                </h1>
                <div className="w-2/5 mt-6 border-t-2 border-gray-300"></div>
            </div>
        </div>
    );
}

export default PageHeader;